/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {motion} from "motion/react";
import DisplayIcon from "../../Icons/DisplayIcon.jsx";

class ListButton extends Component {
    render() {
        let {onClick, text, iconName, className = ""} = this.props
        return (
            <motion.button
                type="button" whileTap={{scale: 0.95}}
                className={`px-2 w-full flex rounded-md  space-x-2.5 h-9 border text-xs items-center text-stone-800 bg-white cursor-pointer ${className}`}
                onClick={(event) => {
                    onClick?.(event)
                }}
            >
                <div className={"border w-6 h-6 flex justify-center items-center rounded text-green-400"}>

                    <DisplayIcon iconName={iconName ?? "IoAdd"} className={"h-4 w-4 "}/>
                </div>
                <div className={"font-medium select-none"}>{text}</div>
            </motion.button>
        );
    }
}

ListButton.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.any,
    iconName: PropTypes.string

};

export default ListButton;